/**
 * @typedef {String} module:EventService.FeedbackCodeEnum
 * @readonly
 * @description The four ways to derscribe the result of a detection
 * @property {String} truePositive "TP"
 * @property {String} trueNegative "TN"
 * @property {String} falsePositive "FP"
 * @property {String} falseNegative "FN"
 */
const feedbackCodeEnum = Object.freeze({
    truePositive: 'TP',
    trueNegative: 'TN',
    falsePositive: 'FP',
    falseNegative: 'FN'
});

export default feedbackCodeEnum;
